module.exports = __webpack_public_path__ + "static/media/B2.8518325d.jpg";